const sectionBannerMediaCss = `
[data-type='section-banner-media'] .banner-media-wrapper[data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-banner-media'] .banner-media-wrapper[data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-banner-media'] .banner-media-container {
  position: relative;
  padding-top: 32%;
  background-image: var(--image-background-desktop);
  background-repeat: no-repeat;
  background-size: cover;
}

[data-type='section-banner-media'] .banner-media-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: var(--overlay-opacity, 0);
  background-color: var(--overlay-color, #000000);
  z-index: 1;
}

[data-type='section-banner-media'] .banner-media-inner {
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

[data-type='section-banner-media'] .banner-media-inner .banner-media-title {
  color: var(--header-title-color, #ffffff);
  margin-bottom: 24px;
}

[data-type='section-banner-media'] .banner-media-inner .banner-media-title h1,
[data-type='section-banner-media'] .banner-media-inner .banner-media-title h2,
[data-type='section-banner-media'] .banner-media-inner .banner-media-title h3 {
  font-size: 36px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
}

[data-type='section-banner-media'] .banner-media-inner .banner-media-title h1:last-child,
[data-type='section-banner-media'] .banner-media-inner .banner-media-title h2:last-child,
[data-type='section-banner-media'] .banner-media-inner .banner-media-title h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-banner-media'] .banner-media-inner .banner-media-title p {
  font-size: 16px;
  margin: 0 0 8px 0 !important;
}

[data-type='section-banner-media'] .banner-media-inner .banner-media-title p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-banner-media'] .banner-media-inner .banner-media-play-icon {
  cursor: pointer;
  background-color: var(--play-icon-background, #ffffff);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
}

[data-type='section-banner-media'] .banner-media-inner .banner-media-play-icon svg {
  width: 48px;
  height: 48px;
  fill: var(--play-icon-color, #000000);
}

[data-type='section-banner-media'] .banner-media-inner .banner-media-play-icon:hover {
  opacity: 0.8;
}

[data-type='section-banner-media'] .banner-media-modal {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: none;
  align-items: center;
  justify-content: center;
}

[data-type='section-banner-media'] .banner-media-modal .banner-media-modal-inner {
  width: min(96vw, 1120px);
  aspect-ratio: 16 / 9;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

[data-type='section-banner-media'] .banner-media-modal .banner-media-modal-inner .banner-media-modal-close {
  position: absolute;
  top: -40px;
  right: 0;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  background-color: transparent !important;
  padding: 0 !important;
}

[data-type='section-banner-media'] .banner-media-modal .banner-media-modal-inner .banner-media-modal-close svg {
  width: 24px;
  height: 24px;
  color: #ffffff !important;
}

[data-type='section-banner-media'] .banner-media-modal .banner-media-modal-inner .banner-media-modal-body {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

[data-type='section-banner-media'] .banner-media-modal .banner-media-modal-inner .banner-media-modal-body .banner-media-iframe {
  width: 100%;
  height: 100%;
  border: none;
  background: #000000;
}

[data-type='section-banner-media'] .banner-media-modal .banner-media-modal-inner .banner-media-modal-body .banner-media-video {
  width: min(90%, 720px);
  max-height: 70vh;
  background: #000000;
}

[data-type='section-banner-media'] .banner-media-modal.is-audio .banner-media-modal-inner {
  aspect-ratio: auto;
  max-width: 760px;
  height: auto;
  min-height: 120px;
}

@container (max-width: 768px) {
  [data-type='section-banner-media'] .banner-media-wrapper[data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-banner-media'] .banner-media-wrapper[data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-banner-media'] .banner-media-container {
    padding-top: 112%;
    background-image: var(--image-background-mobile);
  }

  [data-type='section-banner-media'] .banner-media-inner .banner-media-title {
    margin-bottom: 16px;
  }

  [data-type='section-banner-media'] .banner-media-inner .banner-media-title h1,
  [data-type='section-banner-media'] .banner-media-inner .banner-media-title h2,
  [data-type='section-banner-media'] .banner-media-inner .banner-media-title h3 {
    font-size: 24px;
  }

  [data-type='section-banner-media'] .banner-media-inner .banner-media-play-icon {
    width: 58px;
    height: 58px;
  }

  [data-type='section-banner-media'] .banner-media-inner .banner-media-play-icon svg {
    width: 24px;
    height: 24px;
  }
}
`;
export default sectionBannerMediaCss;
